import { useState, useEffect, useRef } from 'react';
import type { FC } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper';
import { StyledButton } from '@portalCommon/components/StyledButton';
import { useYaotaiGlobalContextState } from '@commonPackage/contexts/yaotaiGlobalContext';
import { toDemoCloudGamePageWithTourist } from '@portalCommon/utils/common';
import { PointBurLEnumPortal, sendEventAndRedirectToConsultWitchParams } from '@portalCommon/utils';
import type { ActivityRecList } from '@portalCommon/services/activity';
import classnames from 'classnames/bind';
import { isHeadlessChrome } from '@yaotai/common-utils';
import { OptimizedImg } from '@commonPackage/components';
import { Button, QRCode } from 'antd';
import API from '@/services';

import { BaseModal } from '../../../recommend/components';
import styles from './index.module.less';
import 'swiper/less';
import { YAOTAI_ICO_PNG } from '@commonPackage/constants';

const cx = classnames.bind(styles);

const ActivityEnterPopup: FC<{ link: string; closeCallback: () => void }> = props => {
  const { link, closeCallback } = props;

  return (
    <BaseModal className={cx('activity-pupup')} onClose={closeCallback} width={610}>
      <div className={cx('content')}>
        <p className={cx('title')}>请选择登录方式</p>
        <div className={cx('box')}>
          <div className={cx('box-left')}>
            <OptimizedImg
              width={118}
              loading="lazy"
              src="https://static.fuxi.netease.com/yaotai/portal/index/lkbzg5c5_760645.png"
              alt=""
            />
            <Button className={cx('enter-btn')} onClick={() => window.open(link)}>
              立即体验
            </Button>
          </div>
          <div className={cx('box-right')}>
            <QRCode
              className={cx('qrcode')}
              errorLevel="H"
              size={128}
              iconSize={26}
              value={link}
              icon={YAOTAI_ICO_PNG}
            />
            <p>手机扫码参加活动</p>
          </div>
        </div>
      </div>
    </BaseModal>
  );
};

const ActivityEnter = () => {
  const [list, setList] = useState<ActivityRecList[]>([]);
  const [popupInfo, setPopupInfo] = useState({
    show: false,
    link: '',
  });

  const indexRef = useRef(0);

  useEffect(() => {
    import.meta.env.VITE_MAIN === 'true' && getActivityEnter();
  }, []);

  const getActivityEnter = async () => {
    const res = await API.activity.getActivityRec();
    const { data } = res || {};
    setList(data);
  };

  const openEnterPopup = () => {
    const { cloud_game_url } = list[indexRef.current];

    setPopupInfo({
      show: true,
      link: cloud_game_url,
    });
  };
  const onClose = () => {
    setPopupInfo({
      show: false,
      link: '',
    });
  };
  return (
    <div className={cx('activity-enter')}>
      <div className={cx('video', !!list.length ? 'has-enter' : 'not-enter')}>
        <video
          src={'https://static.fuxi.netease.com/yaotai/portal/index/lgd2wcov_892350.mp4'}
          muted
          loop
          autoPlay
          controls
        />
      </div>

      {!!list.length && !isHeadlessChrome && import.meta.env.VITE_MAIN === 'true' && (
        <div className={cx('swiper-enter')}>
          <Swiper
            loop
            autoplay
            pagination={{ clickable: true }}
            spaceBetween={10}
            modules={[Pagination, Autoplay]}
            onSlideChange={swiper => (indexRef.current = swiper.realIndex)}>
            {list.map(item => (
              <SwiperSlide key={item.key}>
                <div className={cx('swiper-img')}>
                  <OptimizedImg width={360} src={item.top_image} alt={item.name} onClick={openEnterPopup} />
                </div>
                <dl>
                  <dt>{item.name}</dt>
                  <dd>{item.content}</dd>
                </dl>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className={cx('enter-arrow')} onClick={openEnterPopup}></div>
        </div>
      )}
      {popupInfo.show && <ActivityEnterPopup link={popupInfo.link} closeCallback={onClose} />}
    </div>
  );
};

export const FirstScreen = () => {
  const {
    commonUrls: { demoAid },
  } = useYaotaiGlobalContextState();
  return (
    <div className={cx('first-screen')}>
      <div className={cx('content-par')}>
        <div className={cx('content')}>
          <div className={cx('title')}>开启元宇宙空间全新可能</div>
          <div className={cx('tips')}>
            营销活动<span>·</span>数字文旅<span>·</span>企业元空间<span>·</span>展览展厅<span>·</span>私域元宇宙
          </div>
          <div className={cx('btn-group')}>
            <StyledButton
              styleType="primary"
              className={cx('btn')}
              onClick={() => {
                sendEventAndRedirectToConsultWitchParams(PointBurLEnumPortal.HomepageTopBtnConsult);
              }}>
              咨询合作
            </StyledButton>
            <StyledButton className={cx('btn')} onClick={() => toDemoCloudGamePageWithTourist(demoAid)}>
              立即体验
            </StyledButton>
          </div>
          <ActivityEnter />
        </div>
      </div>
    </div>
  );
};
